export default __webpack_public_path__ + "static/media/face_touchup_icon.6f415894.svg";